<button (click)="toggleMenu()" pTooltip="Profile" [tooltipDisabled]="isTooltipDisabled()">
    <img src="images/avatar/avatar_default.png" alt="avatar" style="width: 32px; height: 32px;" />
    <span class="text-start">
        <strong>{{ nomeUsuario }}</strong>
        <small>{{ perfilNome }}</small>
        <small class="session-timer-label" *ngIf="showSessionTimer">
            {{ 'components.menuProfile.sessionRemaining' | translate }} {{ sessionTimeLabel }}
        </small>
        <button
            type="button"
            class="session-renew-button"
            *ngIf="showSessionTimer"
            (click)="renewSession($event)"
        >
            {{ 'components.menuProfile.renewSession' | translate }}
        </button>
    </span>
    <i class="layout-menu-profile-toggler pi pi-fw" [ngClass]="{ 'pi-angle-down': menuProfilePosition() === 'start' || isHorizontal(), 'pi-angle-up': menuProfilePosition() === 'end' && !isHorizontal() }"></i>
</button>

<ul *ngIf="menuProfileActive()" [@menu]="isHorizontal() ? 'overlay' : 'inline'">
    <li pTooltip="Settings" [tooltipDisabled]="isTooltipDisabled()">
        <button (click)="toggleConfigSidebar()">
            <i class="pi pi-cog pi-fw"></i>
            <span>Configurações</span>
        </button>
    </li>
    <li pTooltip="Profile" [tooltipDisabled]="isTooltipDisabled()">
        <button type="button" (click)="openProfileOnAction()">
            <i class="pi pi-file-o pi-fw"></i>
            <span>Perfil</span>
        </button>
    </li>
    <li pTooltip="Mudar Tenant" [tooltipDisabled]="isTooltipDisabled()" *ngIf="canChangeTenant">
        <button type="button" (click)="openChangeTenantOnAction()">
            <i class="pi pi-building pi-fw"></i>
            <span>{{ 'components.changeTenantModal.menuLabel' | translate }}</span>
        </button>
    </li>
    <li pTooltip="Support" [tooltipDisabled]="isTooltipDisabled()">
        <button [routerLink]="['/documentation']">
            <i class="pi pi-compass pi-fw"></i>
            <span>Suporte</span>
        </button>
    </li>
    <li pTooltip="Logout" [tooltipDisabled]="isTooltipDisabled()" [routerLink]="['/auth/login2']">
        <button class="p-link" (click)="logoutOnAction()">
            <i class="pi pi-power-off pi-fw"></i>
            <span>Logout</span>
        </button>
    </li>
</ul>